// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18a-P","right":"styles_right__18aOl"};